import { delayedSubmit } from '../../../common/scripts/helpers/form';

const setProgressBarSteps = () => {
  const $progressBar = $("[data-progressbar]");
  const steps = $("input[name='category']:checked").attr('id') === 'SFH' ? 4 : 8;
  $progressBar.data('steps', steps);
}

const initIntroStep = () => {
  const $form = $("[data-form]");

  let submitInterval = null;

  $form.on("change submit", e => {
    setProgressBarSteps();
    const $form = $("[data-form]");
    const $inputGroups = $form.find(".input-group");
    $inputGroups.trigger("validate");
    e.preventDefault();
    delayedSubmit($form, submitInterval, () => {
      window.location = $("input[name='category']:checked").val();
    });
  });
};

export { initIntroStep };
